import {
  GridContainer,
  GridItem,
  useReactHookForm,
  BoxSpg,
  ButtonSpg,
  InputFormField,
} from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { ARUniversityEntryRequestFilter } from "../../../../../../types/requests";
import * as yup from "yup";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import { initialARUniversityEntryRequestFilter } from "../../../../../../init/initRequests";
import { clearFilter, updateFilter } from "../../../../../../store/redux/slice/Request/arUniEntryRequestFilter";
import { useEffect } from "react";
import ARUniEntryRequestStatusSelectField from "./fields/ARUniEntryRequestStatusSelectField";
import ARUniEntryRequestRecognitionStatusSelectField from "./fields/ARUniEntryRequestRecognitionStatusSelectField";

const ARUniEntryRequestFilterForm = ({ withUserFilter = false }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const arUniEntryRequestFilter = useAppSelector((state) => {
    return state.Request.arUniEntryRequestFilter;
  });

  const { methods } = useReactHookForm<ARUniversityEntryRequestFilter>({
    defaultValues: arUniEntryRequestFilter,
    validationSchema: () => yup.object({}),
  });

  const { reset } = methods;

  useEffect(() => {
    reset(arUniEntryRequestFilter);
  }, [arUniEntryRequestFilter, reset]);

  const onSubmit = (values) => {
    dispatch(updateFilter({ ...values, page: initialARUniversityEntryRequestFilter.page }));
  };

  const onClear = () => {
    dispatch(clearFilter());
  };

  return (
    <BoxSpg m={2}>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit, (errors) => {
            console.log(errors);
            toast.error(t("m.validation.errors.present"));
          })}
        >
          <GridContainer spacing={4} mt={0}>
            <GridItem>
              <InputFormField fieldName={"applicant"} labelCode={"l.arUniEntryRequest.filter.applicant"} />
            </GridItem>
            <GridItem>
              <InputFormField fieldName={"university"} labelCode={"l.arUniEntryRequest.filter.university"} />
            </GridItem>
            <GridItem>
              <ARUniEntryRequestRecognitionStatusSelectField
                fieldName={"recognitionStatusId"}
                labelCode={"l.arUniEntryRequest.filter.recognitionStatusId"}
              />
            </GridItem>
            <GridItem>
              <ARUniEntryRequestStatusSelectField
                fieldName={"requestStatusId"}
                labelCode={"l.arUniEntryRequest.filter.requestStatusId"}
              />
            </GridItem>
            {withUserFilter && (
              <>
                <GridItem>
                  <InputFormField fieldName={"createdUser"} labelCode={"l.arUniEntryRequest.filter.createdUser"} />
                </GridItem>
                <GridItem>
                  <InputFormField
                    fieldName={"recognizingUniversity"}
                    labelCode={"l.arUniEntryRequest.filter.recognizingUniversity"}
                  />
                </GridItem>
              </>
            )}
          </GridContainer>
          <GridContainer spacing={1}>
            <GridItem sm={12} md={12}>
              <Typography align={"right"}>
                <ButtonSpg type={"submit"} variant={"contained"}>
                  {t("l.btn.search")}
                </ButtonSpg>
                <ButtonSpg type={"button"} variant={"outlined"} ml={2} onClick={onClear}>
                  {t("l.btn.clear")}
                </ButtonSpg>
              </Typography>
            </GridItem>
          </GridContainer>
        </form>
      </FormProvider>
    </BoxSpg>
  );
};
export default ARUniEntryRequestFilterForm;
